import { useEffect, useCallback, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { throttle } from '../utils/eventUtils';
import { NOW_PLAYING_TEMPLATE } from '../types/templates/nowPlaying';
import { VIDEO_NOW_PLAYING_TEMPLATE, } from '../types/templates/videoNowPlaying';
import { ENABLE_MSHOP_BOTTOM_OVERRIDE } from '../actions';
export default function IOSMShopHandler() {
    const dispatch = useDispatch();
    const { overlayTemplates } = useSelector((state) => state.TemplateStack);
    const media = useSelector((state) => state.Media);
    const throttledScrollEventListener = useCallback(throttle(scrollEventCallback, 100), []);
    const resizeObserver = useRef(new ResizeObserver(() => {
        throttledScrollEventListener();
    }));
    const rootElement = useRef(null);
    const [scrollEventListenerAdded, setScrollEventAdded] = useState(false);
    const hasOverlay = overlayTemplates.length > 0;
    const isAudioNPVShowing = hasOverlay &&
        !!overlayTemplates.find((template) => template.interface === NOW_PLAYING_TEMPLATE);
    const videoNPVTemplate = overlayTemplates.find((template) => template.interface === VIDEO_NOW_PLAYING_TEMPLATE);
    const isVideoNPVShowing = hasOverlay && !!videoNPVTemplate;
    const isNowPlaying = isAudioNPVShowing || isVideoNPVShowing;
    useEffect(() => {
        rootElement.current = document.getElementById('root');
        return () => {
            window.removeEventListener('scroll', throttledScrollEventListener);
            if (resizeObserver.current && rootElement.current) {
                resizeObserver.current.unobserve(rootElement.current);
            }
        };
    }, []);
    useEffect(() => {
        // Assign listeners only when playback started and transport component is visible
        if (media && (media === null || media === void 0 ? void 0 : media.mediaId) && !isNowPlaying && !scrollEventListenerAdded) {
            setScrollEventAdded(true);
            // scroll event listener to check whether we have reached end of page
            window.addEventListener('scroll', throttledScrollEventListener);
            // ResizeObserver to check for height modifications happening due to view engine
            if (window.ResizeObserver && rootElement.current) {
                resizeObserver.current.observe(rootElement.current);
            }
        }
    }, [isNowPlaying, media === null || media === void 0 ? void 0 : media.mediaId]);
    function scrollEventCallback() {
        // check whether we have reached the bottom of the page by calculating root element height
        // and vertical scroll
        const enableMShopBottomOverride = rootElement.current &&
            window.innerHeight + window.scrollY >= rootElement.current.offsetHeight;
        dispatch({
            type: ENABLE_MSHOP_BOTTOM_OVERRIDE,
            payload: { enableMShopBottomOverride: !enableMShopBottomOverride },
        });
    }
    return null;
}
